import React from 'react'
import Form from '../../components/Form'
import fields, { ValidatePasswordFormData } from './fields'
import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import { toast } from 'react-toastify'

interface Props {
  onSubmit: () => void
}

const ValidatePasswordForm: React.FC<Props> = ({ onSubmit }) => {
  const { request } = useRequest()

  return (
    <Form<ValidatePasswordFormData>
      buttonLabel="ENVIAR"
      fields={fields}
      onSubmit={({ password }) => handleFormSubmit({
        request: request({
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/user/validate-password?password=${password}`,
        }),
        onValidationErrors: () => toast.error('Erros de validacao.'),
        onSuccess: ({ data }) => {
          if (data.valid) {
            onSubmit()
            toast.success('Senha validada.')
          } else {
            toast.error('Senha não validada.')
          }
        },
        onFailure: () => toast.error('Erro ao confirmar senha.'),
      })}
    />
  )
}

export default ValidatePasswordForm
